import React, { useState } from 'react'
import {
    Button,
    DialogActions,
    InputLabel,
    TextField,
    IconButton,
    FormHelperText,
    DialogContent
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import config from "../../../../constants/config.json";
import { useDispatch, useSelector } from 'react-redux';
import { set } from 'date-fns';
import { setOpenModal } from '../../store/controlPanelSlice';
import { apiThunkForSupportModal } from '../../store/apiThunkForSupportModal';
import { unwrapResult } from '@reduxjs/toolkit'; // Pour gérer les rejets comme exceptions
import { useTranslation } from 'react-i18next';
import { addNotification } from '../../../Notifications/store/notificationsSlice';
import NotificationBuilder from '../../../Notifications/utils/NotificationBuilder';
export default function SupportModal({ }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [files, setFiles] = useState([]);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const { localAvatar } = useSelector((state) => state.auth);
    const MAX_FILE_SIZE = 5 * 1024 * 1024;
    const ALLOWED_MIME_TYPES = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/svg+xml",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "text/plain",
        "application/xml",
        "application/vnd.ms-excel", // Excel .xls
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" // Excel .xlsx
    ];
    const [open, setOpen] = React.useState(true);

    const domain = window.location.hostname;
    let formattedSubDomain = "";
    let subDomain = "";

    if (
        domain.indexOf(".") < 0 ||
        domain.split(".")[0] === "example" ||
        domain.split(".")[0] === "lvh" ||
        domain.split(".")[0] === "www"
    ) {
        subDomain = "";
    } else {
        subDomain = domain.split(".")[0];
    }
    function isPrivateIP(ip) {
        return (
            ip.startsWith("10.") ||
            ip.startsWith("172.") && parseInt(ip.split(".")[1]) >= 16 && parseInt(ip.split(".")[1]) <= 31 ||
            ip.startsWith("192.168.") ||
            ip === "127.0.0.1"
        );
    }


    if (/*LOCAL || */ domain.startsWith("localhost") || isPrivateIP(domain)) {
        subDomain = "dev";
    }
    if (subDomain) {
        formattedSubDomain = subDomain.charAt(0).toUpperCase() + subDomain.slice(1);
    }
    const onClose = () => {
        dispatch(setOpenModal(null));
    }
    const handleFileChange = (event) => {
        const newFiles = Array.from(event.target.files);

        const validFiles = newFiles.filter((file) => {
            // Rejeter CSV
            let errorNotification = null;
            if (file.type === "text/csv" || !ALLOWED_MIME_TYPES.includes(file.type)) {
                errorNotification = NotificationBuilder.error()
                    .withHeader("file_csv_not_allowed", true, { fileName: file.name })
                    .build()
            }
            // Vérifier la taille
            else if (file.size > MAX_FILE_SIZE) {
                errorNotification = NotificationBuilder.error()
                    .withHeader("file_csv_not_allowed", true, { fileName: file.name })
                    .build()
            }

            if (errorNotification) {
                dispatch(addNotification(errorNotification));
                return false;
            }

            return true;
        });
        setFiles((prevFiles) => [...prevFiles, ...validFiles]);
        event.target.value = ""; // réinitialiser input
    };
    const handleRemoveFile = (index) => {
        setFiles(files.filter((_, i) => i !== index));
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };


    const handleSubmit = async () => {
        let errorNotification = null;
        if (!title) {
            errorNotification = NotificationBuilder.error()
                    .withHeader("form_title_required", true)
                    .build();
        }
        else if (!description) {

            errorNotification = NotificationBuilder.error()
                    .withHeader("form_description_required", true)
                    .build();
        }
        if (errorNotification) {
            dispatch(addNotification(errorNotification));
            return;
        }
        try {
            const ticketTitle = title.startsWith(`[${formattedSubDomain}][Aifel]`)
                ? title
                : `[${formattedSubDomain}][Aifel] ${title}`;
            const fullDescription = `${description}`;
            let formData = null;
            if (files.length > 0) {
                formData = new FormData();
                files.forEach(file => {
                    formData.append("file", file); // ou "files[]" si ton backend attend plusieurs
                });
            }
            const resultAction = await dispatch(
                apiThunkForSupportModal({
                    ticketTitle,
                    fullDescription,
                    formData
                })
            );
            unwrapResult(resultAction);
            setTimeout(() => {
                onClose();
            }, 1500);

        } catch (err) {
            console.error("[SupportModal Error]", err);


        }
    };

    return (
        <>
            <DialogContent>
                <InputLabel id="title-label" sx={{ fontSize: "14px", marginTop: "20px", color: "#364152" }}>
                    {t("Titre")}     <span style={{ color: "red" }}>*</span>
                </InputLabel>
                <TextField
                    margin="dense"
                    fullWidth
                    variant="standard"
                    placeholder={t('form_title_placeholder')}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    InputProps={{
                        disableUnderline: true,
                        sx: {
                            backgroundColor: '#EEF2F6',
                            borderRadius: '8px',
                            paddingX: 1,
                            paddingY: 1.5,
                        },
                    }}

                />

                <InputLabel id="description-label" sx={{ fontSize: "14px", marginTop: "20px", color: "#364152" }}>

                    {t("description")} <span style={{ color: "red" }}>*</span>

                </InputLabel>
                <TextField
                    margin="dense"
                    fullWidth
                    multiline
                    rows={5}
                    variant="standard"
                    placeholder={t('form_description_placeholder')}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    InputProps={{
                        disableUnderline: true,
                        sx: {
                            backgroundColor: '#EEF2F6',
                            borderRadius: '8px',
                            paddingX: 1,
                            paddingY: 1.5,
                        },
                    }}
                    required
                />

                <InputLabel id="file-label" sx={{ fontSize: "15px", marginTop: "20px", color: "#364152" }}>
                    {t("Attachment")}
                </InputLabel>
                <FormHelperText sx={{ marginTop: "2px", color: "#6B7280", fontSize: "14px" }}>
                    {t("Supported_formats")} : JPG, JPEG, PNG, GIF, TXT, DOCX, PDF, SVG, XML — {t("file_maxSize")}
                </FormHelperText>
                <Button
                    variant="outlined"
                    component="label"
                    sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        marginTop: "10px",
                        color: "#364152",
                        borderColor: "#000000ff",
                        "&:hover": {
                            cursor: "pointer",
                            backgroundColor: "#69D945",
                            color: "#fff",
                            borderColor: "#69D945",
                        }
                    }}
                >
                    {t("chose_attachment")}
                    <input type="file" hidden multiple onChange={handleFileChange} />
                </Button>

                {files.length > 0 && (
                    <div style={{ marginTop: "10px" }}>
                        {files.map((f, i) => (
                            <div
                                key={i}
                                style={{
                                    fontSize: "14px",
                                    color: "#364152",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    backgroundColor: "#EEF2F6",
                                    borderRadius: "8px",
                                    padding: "8px 12px",
                                    marginTop: "5px",
                                }}
                            >
                                <span>📎 {f.name}</span>
                                <IconButton size="small" onClick={() => handleRemoveFile(i)} sx={{ color: "#69D945" }}>
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            </div>
                        ))}
                    </div>
                )}

                <DialogActions className="invitation-action" sx={{ marginTop: "20px" }}>
                    <Button className="cancel-invitation" sx={{ color: "#69D945" }} onClick={onClose} > {t("cancel")} </Button>
                    <Button className="send-invitation" sx={{ color: "#69D945" }} onClick={handleSubmit}  > {t("send")}</Button>
                </DialogActions>
            </DialogContent>



        </>
    )
}
